import { FC } from 'react';
import { COLUMN_NAMES } from 'governanceTags/constants/columnNames';
import { numberWithCommas } from 'shared/utils/strUtil';

import styles from '../GovernanceTagsTableController.module.scss';

interface ResourceCostOrNameFormatterProps {
  value: number;
  cost?: number;
  column?: { name: string };
}

const ResourceCostOrNameFormatter: FC<ResourceCostOrNameFormatterProps> = ({ value, column }) => {
  if (column?.name === COLUMN_NAMES.RESOURCE_COST) {
    return <span className={styles.resourceCostOrNameCell}>${numberWithCommas(value, 2)}</span>;
  }

  return <span className={styles.resourceCostOrNameCell}>{value}</span>;
};

export default ResourceCostOrNameFormatter;
